import type { AxiosResponse } from 'axios';
import API from './axios';

export const SUPPORT_TICKET_MAX_BODY_LENGTH = 20_000;

export interface CreateSupportTicketRequest {
  body: string;
  contactEmail?: string;
  contactPhone?: string;
}

export interface CreateSupportTicketResponse {
  ok: boolean;
}

export const createSupportTicketApiCall = (
  payload: CreateSupportTicketRequest
): Promise<AxiosResponse<CreateSupportTicketResponse>> => {
  return API.post<CreateSupportTicketResponse>('api/support/tickets', payload);
};
